import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import CircularProgress from '@mui/material/CircularProgress';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputAdornment from '@mui/material/InputAdornment';

import NumberInput from "./NumberInput.js";

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import { ReactSortable, Sortable, MultiDrag, Swap } from "react-sortablejs";

import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2

import CardMedia from '@mui/material/CardMedia';

import testImage1 from "./test-1.jpeg"
import testImage2 from "./test-2.jpeg"
import testImage3 from "./test-3.jpeg"
import testImage4 from "./test-4.jpeg"

import DeleteIcon from '@mui/icons-material/Delete';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import OpenWithIcon from '@mui/icons-material/OpenWith';

import Divider from '@mui/material/Divider';

import axios from 'axios';
import SheetMusicPlayer from './SheetMusicPlayer.js';
import settingSystem from "../SettingSystem.js"
import Camera from "./Camera.js";

import ReactCrop, {
	centerCrop,
	makeAspectCrop,
	Crop,
	PixelCrop,
	centerAspectCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import ImageCroppingPage from "./ImageCroppingPage.js"

// import Switch from '@mui/material/Switch';
import cbor from 'cbor-js';

import TextManager from '../TextManager.js';

export default class ScoreManagementPage extends React.Component {

	state = {
		navigationMenuOpened: false,
		navigationMenuAnchor: null,
		list: [
			// {id: 0, image: testImage1, file: null},
			// {id: 1, image: testImage2, file: null},
			// {id: 2, image: testImage3, file: null},
			// {id: 3, image: testImage4, file: null},
		],

		showCameraScreen: false,


		uncroppedThumbnail: null,
		uncroppedImage: null,
		errorMessage: null,
		optionsMenuOpened: false,
		imageBeingViewed: null,

		//shouldClearFileList: false,


	}

	// fileInputElem = React.createRef();
	// cameraInputElem = React.createRef();

	xmlFileInputElem = React.createRef();
	cameraInputRef = React.createRef();
	photoUploadInputRef = React.createRef();
	pdfFileInputElem = React.createRef();


	componentDidMount() {
		// var list = []
		// for (let i = 0; i < 4; i++) {
		// list.push({id: i})
		// }
		// this.setState({list: list})

		

		

		// Prevent mouse drap action opening new tab
		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		}
	}


	sendProcessImageRequest = async () => {
		var formData = new FormData();
		for (const item of this.state.list) {
			formData.append("sheets", item.file);
		}

		var success = await this.props.scoreProcessingProgressManager.sendProcessingRequest(`/api/omr`, formData);

		if(success){
			this.props.setFileList?.call(this, this.state.list);
		}
		
		return success;
	};

	clearFileList = async () => {
		this.setState({ list: [] });
	}

	async addFile(file, thumbnailUrl) {
		var fileList = this.state.list;
		// let dataUrl = await new Promise((resolve, reject) => {
		// 	var reader = new FileReader();
		// 	reader.onload = () => {
		// 		resolve(reader.result);
		// 	};
		// 	reader.readAsDataURL(file)
		// });

		fileList.push(
			{ id: fileList.length, image: thumbnailUrl, file: file },
		);
		this.setState({ list: fileList })
	}


	render() {
		const handleChange = (event: SelectChangeEvent) => {
			this.setState({ noteNameMode: event.target.value })
		};

		const setDropdownValue = (event, stateName) => {
			//console.log(stateName);
			this.setState({ [stateName]: event.target.value });
		}

		const onTextInputChanged = (event, stateName) => {
			this.setState({ [stateName]: event.target.value });
		}

		const openNavigationMenu = (event) => {
			this.setState({ navigationMenuAnchor: event.currentTarget });
			this.setState({ navigationMenuOpened: true });
		}

		const closeNavigationMenu = (event) => {
			this.setState({ navigationMenuOpened: false });
		}

		const removeFile = (index) => {
			var list = this.state.list;
			list.splice(index, 1);
			this.setState({ list: list });
		}

		const scaleImage = (image, scale) => {
			var canvas = document.createElement("canvas"),
				ctx = canvas.getContext("2d");



			canvas.width = image.width * scale;
			canvas.height = image.height * scale;

			ctx.scale(scale, scale)

			ctx.drawImage(image, 0, 0);


			const newUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
			return newUrl;
		}

		const createThumbnail = async (url) => {
			var image = new Image();
			image.src = url;

			// return url;

			return new Promise((resolve, reject) => {
				image.onload = () => {
					const thumbnailLongSide = 640.0;
					let thumbnailScale = thumbnailLongSide / image.height;
					if (image.width > image.height) {
						thumbnailScale = thumbnailLongSide / image.width;
					}

					resolve(scaleImage(image, thumbnailScale));
				}
			});
		}

		// const createThumbnail

		const onFileInputElementChanged = async (inputElement) => {
			//var fileList = this.state.list;
			//for (const file of inputElement.files) {
			const imageUrl = await this.readFileDataAsUrl(inputElement.files[0]);
			const thumbnailUrl = await createThumbnail(imageUrl);

			await this.openCropDialog(thumbnailUrl, imageUrl);

			// fileList.push(
			// 	{id: fileList.length, image: dataUrl, file: file},
			// );
			//}
			//this.setState({ list: fileList })

			inputElement.value = null
		}

		const onXmlFileInputElementChanged = async (inputElement) => {
			if (inputElement.files.length > 0) {
				let success = await this.props.scoreProcessingProgressManager.sendProcessMxlRequest(inputElement.files[0]);
				inputElement.value = null;
				if (success) {
					this.props.close();
					this.props.setFileList?.call(this, []);
				}
			}
		}

		const onPdfFileInputElementChanged = async (inputElement) => {
			if (inputElement.files.length > 0) {
				let success = await this.props.scoreProcessingProgressManager.sendProcessPdfRequest(inputElement.files[0]);
				inputElement.value = null;
				if (success) {
					this.props.close();
					this.props.setFileList?.call(this, []);
				}
			}
		}

		const onFileDropped = async (event) => {
			//console.log(event)
			event.preventDefault();
			event.stopPropagation();
			this.setState({ dragActive: false });
			if (event.dataTransfer.files) {
				if (/\.(xml|musicxml|mxl)$/.test(event.dataTransfer.files[0].name)) {
					let success = await this.props.scoreProcessingProgressManager.sendProcessMxlRequest(event.dataTransfer.files[0]);
					if (success) {
						this.props.close();
						this.props.setFileList?.call(this, []);
					}
					// else {
					// 	this.setState({ errorMessage: TextManager.getText("score_process_xml_failed") })
					// }
				}
				else if (/\.(pdf)$/.test(event.dataTransfer.files[0].name)) {
					let success = await this.props.scoreProcessingProgressManager.sendProcessPdfRequest(event.dataTransfer.files[0]);
					if (success) {
						this.props.close();
						this.props.setFileList?.call(this, []);
					}
				}
				else {
					// TODO: imeplement
					let imageUrl = await this.readFileDataAsUrl(event.dataTransfer.files[0]);
					// onScoreImageReceived(url);
					const thumbnailUrl = await createThumbnail(imageUrl);
					await this.openCropDialog(thumbnailUrl, imageUrl);
				}
				// for (const file of event.dataTransfer.files) {
				// 	await this.openCropDialog(file);
				// }
				// handleFiles(e.dataTransfer.files);

				// this.addFile(event.dataTransfer.files[0])
			}
		}

		const onDragOver = (event) => {
			event.preventDefault();
			event.stopPropagation();
			if (event.type === "dragenter" || event.type === "dragover") {
				this.setState({ dragActive: true });
			} else if (event.type === "dragleave") {
				this.setState({ dragActive: false });
			}
		}

		return (

			<div className="PopupPage">
				{/*<CloseIcon sx={{float:"right", left:"100px"}}/>*/}

				<div className="PageTitle">{TextManager.getText("score_management")}</div>

				<List className="PageList" onDrop={onFileDropped} onDragOver={onDragOver} onDragEnter={onDragOver} onDragLeave={onDragOver}>
					<ReactSortable
						list={this.state.list}
						setList={(newList) => this.setState({ list: newList })}
						draggable=".DraggableCard"
						handle=".DraggableHandle"


						style={{
							display: "grid",
							gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
							// gridTemplateRows: "300px 300px",
							// justifyContent: "center",
							gridGap: "20px",
						}}
					>
						{this.state.list.map((item, index) => (
							<Card className="DraggableCard" key={index} sx={{
								minWidth: "150px",
								width: "100%",
								height: "150px",
								margin: "auto auto",
								// margin: "10px 10px 10px 10px",
							}}>
								<CardMedia
									sx={{
										height: "75%",
									}}
									image={item.image}
									title="green iguana"
									onClick={(e) => {
										this.setState({ imageBeingViewed: item.image });
									}}
								/>

								<Stack direction="row" sx={{
									height: "25%",
									justifyContent: "space-between",
									alignItems: "center",
									padding: "0 0px 0 8px"
								}}>
									<Stack direction="row" spacing="6px" sx={{
										height: "100%",
										alignItems: "center",
									}}>
										<Box sx={{ width: "20px", height: "100%" }}>
											<OpenWithIcon className="DraggableHandle" sx={{
												// fill: "black",
												// height: "50%", 
												width: "100%",
												height: "100%",
												margin: "auto auto",
											}} />
										</Box>

										<Typography sx={{
											fontSize: "18px",
											// fontWeight: "400"
										}}>
											{TextManager.getText("page")} {this.state.list.indexOf(item) + 1}
										</Typography>
									</Stack>
									<IconButton size="small" onClick={e => removeFile(index)} ><DeleteIcon sx={{
										fill: "red",
										// height: "50%", 
										width: "80%",
									}} /></IconButton>

								</Stack>
							</Card>


						))}

						<Card className="addButton_scoreManagementPage" sx={{
							minWidth: "150px",
							width: "100%",
							height: "150px",
							margin: "auto auto",

							// margin: "10px 10px 10px 10px",
						}}>
							<IconButton onClick={openNavigationMenu} sx={{
								width: "100%",
								height: "100%",
								borderRadius: "0px",
							}}>
								<Stack direction="column" sx={{
									justifyContent: "space-between",
									alignItems: "center",

								}}>

									<AddCircleOutlineIcon sx={{
										width: "auto",
										height: "50px",
										fill: "url(#gradientId)"
									}} />
									<Typography sx={{
										fontSize: "18px",
										color: "rgba(0,130,240,1)"
										// fontWeight: "400"
									}}>
										{TextManager.getText("new_page")}
									</Typography>

								</Stack>

							</IconButton>

						</Card>
					</ReactSortable>
				</List>

				<Box sx={{ marginBottom: 1 }}>
					<Typography sx={{ fontSize: 20 }}>
						{TextManager.getText("scan_guide_title")}
						
						<ul style={{ fontSize: 16, marginTop: 0, marginBottom: 0 }}>
							<li>{TextManager.getText("scan_guide_1")}</li>
							<li>{TextManager.getText("scan_guide_2")}</li>
							<li>{TextManager.getText("scan_guide_3")}</li>
						</ul>
					</Typography>

					<Typography sx={{ fontSize: 16 }}>
						{TextManager.getText("scan_disclaimer")}
					</Typography>
				</Box>

				{/* <Stack spacing={1} justifyContent="center" alignItems="center"> */}
					<Stack
						spacing={this.props.isNarrowScreen ? 1 : 2}
						direction={this.props.isNarrowScreen ? "column" : "row"}
						justifyContent="center"
						sx={{
							width: "100%"
						}}
					// sx={{
					// 	padding: "0px " + (this.props.isNarrowScreen? "20" : "20") + "px"
					// }}
					>
						<Button onClick={async () => {
							let success = await this.sendProcessImageRequest();
							if (success) {
								this.props.close();
							}

						}} variant="contained" disabled={this.state.list.length <= 0}>{TextManager.getText("generate")}</Button>
						{/* <Button onClick={() => this.pdfFileInputElem.current.click()} variant="contained">{TextManager.getText("scan_pdf")}</Button>
						<Button onClick={() => this.xmlFileInputElem.current.click()} variant="contained">{TextManager.getText("load_xml")}</Button> */}
						{/* <Button onClick={() => this.setState({ optionsMenuOpened: true })} variant="contained">Advanced</Button> */}
						{this.props.isNarrowScreen ? <Button onClick={this.props.close} variant="contained">{TextManager.getText("cancel")}</Button> : null}
						{!this.props.isNarrowScreen ? <Button onClick={this.props.close} variant="contained" sx={{ width: "120px" }}>{TextManager.getText("cancel")}</Button> : null}
					</Stack>

					{/* {!this.props.isNarrowScreen ? <Button onClick={this.props.close} variant="contained" sx={{ width: "120px" }}>Cancel</Button> : null} */}
				{/* </Stack> */}

				<Menu
					anchorEl={this.state.navigationMenuAnchor}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={this.state.navigationMenuOpened}
					onClose={closeNavigationMenu}
				>
					<Typography sx={{
						margin: "0px 10px 5px 10px",
						fontSize: "18px",
					}}>
						{TextManager.getText("select_upload_method")}
					</Typography>
					<Divider />
					<MenuItem onClick={
						(event) => {
							const input = this.cameraInputRef?.current;

							if (input != null) {
								const cameraCaptureSupported = input.capture != undefined;

								if (cameraCaptureSupported) {
									input.click();
								} else {
									;
									this.props.openCameraScreen();
								}
							}

							closeNavigationMenu();
						}
					} >
						<ListItemIcon>
							<CameraAltIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>{TextManager.getText("camera")}</ListItemText>
					</MenuItem>
					<MenuItem onClick={
						async (event) => {
							const input = this.photoUploadInputRef?.current;

							if (input != null) {
								input.click();
							}

							closeNavigationMenu();
						}
					} >
						<ListItemIcon>
							<UploadFileIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>{TextManager.getText("local_storage")}</ListItemText>

					</MenuItem>

				</Menu>


				<Dialog open={this.state.errorMessage != null} >
					<Box sx={{
						margin: "50px 50px",
					}}>
						<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
							<ErrorIcon />
							<Typography>{this.state.errorMessage}</Typography>
							<Button onClick={() => this.setState({ errorMessage: null })} variant="contained">Close</Button>
						</Stack>
					</Box>
				</Dialog>

				<input ref={this.cameraInputRef} hidden type="file" accept="image/*" capture="camera" onChange={e => onFileInputElementChanged(e.target)} />
				<input ref={this.photoUploadInputRef} hidden type="file" accept="image/*" onChange={e => onFileInputElementChanged(e.target)} />
				<input ref={this.xmlFileInputElem} type="file" accept=".xml,.mxl" hidden onChange={e => onXmlFileInputElementChanged(e.target)} />
				<input ref={this.pdfFileInputElem} type="file" accept=".pdf" hidden onChange={e => onPdfFileInputElementChanged(e.target)} />

				<Dialog open={this.state.uncroppedThumbnail != null} fullScreen={this.props.isNarrowScreen} >
					<ImageCroppingPage
						imageSrc={this.state.uncroppedImage}
						thumbnailSrc={this.state.uncroppedThumbnail}
						onImageClippingFinished={event => this.addFile(event.file, event.thumbnailUrl)}
						onImageError={event => {
							this.setState({
								uncroppedThumbnail: null,
								errorMessage: TextManager.getText("image_format_error"),
							});
						}}
						close={() => this.setState({ uncroppedThumbnail: null })}
					/>
				</Dialog>

				<Dialog open={this.state.optionsMenuOpened} fullScreen={this.props.isNarrowScreen} >
					<div className="PopupPage">
						<List className="PageList">
							<ListItem>
								<ListItemText primary="Use pre-processing" />
								<Switch edge="end" checked={settingSystem.getSetting("usePreprocessing")} onChange={(e) => {
									settingSystem.setSetting("usePreprocessing", !settingSystem.getSetting("usePreprocessing"), this)
								}} />
							</ListItem>

							<ListItem>
								<ListItemText primary="Merge tracks" />
								<Box sx={{ minWidth: 120 }}>
									<FormControl fullWidth>
										<InputLabel id="demo-simple-select-label"></InputLabel>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={settingSystem.getSetting("mergeTracksOption")}
											onChange={(e) => {
												settingSystem.setSetting("mergeTracksOption", e.target.value, this)
											}}
										>
											<MenuItem value={"no"}>Never</MenuItem>
											<MenuItem value={"fix_disconnected"}>Fix invalid tracks</MenuItem>
											{/* <MenuItem value={"piano_only"}>Merge all into piano</MenuItem> */}
										</Select>
									</FormControl>
								</Box>
							</ListItem>


						</List>

						<Stack spacing={2} direction="row" justifyContent="center">

							<Button onClick={(e) => this.setState({ optionsMenuOpened: false })} variant="contained">Confirm</Button>
						</Stack>
					</div>
				</Dialog>

				<Dialog
					open={this.state.imageBeingViewed != null}
					fullScreen={this.props.isNarrowScreen}
				>
					<img src={this.state.imageBeingViewed} />

					<IconButton size="small"
						onClick={e => {
							this.setState({ imageBeingViewed: null });
						}}
						sx={{
							position: "absolute",
							top: "4px",
							right: "4px",
						}}
					>
						<CloseIcon sx={{
							fill: "white",
							stroke: "white",
							strokeWidth: "2px",
							// height: "50%", 
							width: "100%",
							filter: "drop-shadow(0px 0px 2px rgb(0 0 0 / 0.4))",
						}} />
					</IconButton>
				</Dialog>

			</div>
		);
	}

	async readFileDataAsUrl(file) {
		let dataUrl = await new Promise((resolve, reject) => {
			var reader = new FileReader();
			reader.onload = () => {
				resolve(reader.result);
			};
			reader.readAsDataURL(file);
		});

		return dataUrl;
	}

	openCropDialog(thumbnailUrl, imageUrl) {
		this.setState({
			uncroppedThumbnail: thumbnailUrl,
			uncroppedImage: imageUrl,
		});
	}
}